import { render, staticRenderFns } from "./ForgetPassword.vue?vue&type=template&id=073209e6"
import script from "../../services/password/forget-password.js?vue&type=script&lang=js&external"
export * from "../../services/password/forget-password.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/password/forget-password.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports